import { FunctionalComponent, h } from "preact";
import Container from "../../components/container";

const DeviceScene: FunctionalComponent = () => {
    return (
        <Container>
            <h1>Device</h1>
            <p>This is the Device component.</p>
        </Container>
    )
}

export default DeviceScene;